import React, {Component} from 'react'
import ReactModal from 'react-modal';
import PropTypes from 'prop-types'
import {connect} from "react-redux";
import {modalClose} from "../../actions/ModalActions";

const customStyle = {
    overlay: {
        backgroundColor: 'rgba(32, 33, 35, 0.6)',
        zIndex: 99999,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '10px',
        padding: '30px',
    },
};

class Modal extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
    };

    handleClose = () => {
        const {id, modalClose} = this.props;
        modalClose(id);
    };

    showModal = () => {
        const {id, modal} = this.props;

        return modal.modals[id] && modal.modals[id].show === true;
    };

    render() {
        const {id, children} = this.props;
        const showModal = this.showModal();

        return <span>
            <ReactModal
                isOpen={showModal}
                appElement={document.getElementById(id)}
                style={customStyle}
                onRequestClose={this.handleClose}
            >
                <a className="ReactModal__CloseButton" onClick={this.handleClose}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24">
                        <path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z" />
                    </svg>
                </a>
                {typeof children === 'function' ? children(this.handleClose) : children}
            </ReactModal>

            <div id={id} />
        </span>
    }
}

export default connect(
    state => ({
        modal: state.modal,
    }),
    dispatch => ({
        modalClose: name => dispatch(modalClose(name)),
    })
)(Modal)